import { createContext } from 'react';
import PropTypes from 'prop-types';

export const HomePageContext = createContext({});

export function HomePageContextProvider({
    children,
    isDesktop,
    isMobile,
    isTablet,
    isLoggedInUser,
    userType,
}) {
    return (
        <HomePageContext.Provider
            value={{
                isMobile,
                isTablet,
                isDesktop,
                isLoggedInUser,
                userType,
            }}
        >
            {children}
        </HomePageContext.Provider>
    );
}

HomePageContextProvider.propTypes = {
    children: PropTypes.node,
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
    isDesktop: PropTypes.bool.isRequired,
    isLoggedInUser: PropTypes.bool.isRequired,
    userType: PropTypes.string.isRequired,
};
